import { provideRouter, Routes } from '@angular/router';
import { autoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { hasPermission } from '@tiltgroup/web-components';
import { Permission } from '@shared/interfaces/permission';
import { sideMenuPurgeGuard } from '@shared/guards/side-menu-purge.guard';
import { CallbackComponent } from './pages/callback/callback.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';

export enum AppRoutes {
  SHIPMENTS = 'shipments',
  LOADS = 'loads',
  QUOTES = 'quotes',
  BIDS = 'bids',
  OVERVIEW = 'overview',
  CLIENTS = 'clients',
  CARRIERS = 'carriers',
  ORGANIZATION_SALES_REPRESENTATIVES = 'organization/sales-representatives',
  ORGANIZATION_SERVICES = 'organization/services',
  ORGANIZATION_TEAMS = 'organization/teams',
  COMMISSION_SUMMARY = 'finance/commission-summary',
  CLAIMS = 'finance/claims',
  CHECK_CALLS = 'check-calls',
  TENDERS = 'tenders',
  PERSONAL_SETTINGS = 'personal-settings',
  WORKSPACE_SETTINGS = 'workspace-settings',
  TOOLS = 'tools',
}

export const APP_ROUTES: Routes = [
  { path: '', redirectTo: AppRoutes.QUOTES, pathMatch: 'full' },
  // "home" redirects to quotes for now.
  // { path: 'home', redirectTo: AppRoutes.QUOTES, pathMatch: 'full' },
  {
    path: AppRoutes.QUOTES,
    loadChildren: () =>
      import('./pages/quotes/quotes-routing').then((m) => m.QUOTES_ROUTES),
    canMatch: [
      autoLoginPartialRoutesGuard,
      () => hasPermission(Permission.VIEW_LTL_QUOTE_REQUEST),
    ],
    canDeactivate: [sideMenuPurgeGuard],
  },
  {
    path: `${AppRoutes.QUOTES}/:id`,
    outlet: 'side',
    loadChildren: () =>
      import('./pages/quotes/pages/quote-profile/quote-profile-routing').then(
        (m) => m.QUOTE_PROFILE_ROUTES
      ),
    canMatch: [
      autoLoginPartialRoutesGuard,
      () => hasPermission(Permission.VIEW_LTL_QUOTE_REQUEST),
    ],
  },
  {
    path: AppRoutes.SHIPMENTS,
    loadChildren: () =>
      import('./pages/shipments/shipments-routing').then(
        (m) => m.SHIPMENTS_ROUTES
      ),
    canMatch: [autoLoginPartialRoutesGuard],
    canDeactivate: [sideMenuPurgeGuard],
  },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: 'forbidden', component: UnauthorizedComponent },
  { path: 'callback', component: CallbackComponent },
];

export const routerConfig = provideRouter(APP_ROUTES);
